export default "__VITE_ASSET__DOrJwB49__"